import { useEffect, useState } from 'react'
import { AlertCircle, X } from 'lucide-react'

export default function ApiFeedback() {
  const [message, setMessage] = useState('')

  useEffect(() => {
    let timer
    const showError = (event) => {
      setMessage(event.detail || 'No se pudo completar la acción.')
      clearTimeout(timer)
      timer = setTimeout(() => setMessage(''), 6000)
    }
    window.addEventListener('dayflow-api-error', showError)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('dayflow-api-error', showError)
    }
  }, [])

  if (!message) return null

  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[200] w-[calc(100%-2rem)] max-w-lg rounded-2xl border border-red-200 dark:border-red-900 bg-white dark:bg-gray-900 shadow-2xl p-4 flex items-start gap-3" role="alert">
      <AlertCircle className="text-red-500 shrink-0" size={21} />
      <p className="text-sm font-semibold text-gray-800 dark:text-gray-100 flex-1">{message}</p>
      <button onClick={() => setMessage('')} className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200" aria-label="Cerrar aviso">
        <X size={18} />
      </button>
    </div>
  )
}
